import axiosInstance from '../axiosInterceptor/axiosInstance'

const youtubeUnlink = async (data) => {
  const { orgId } = data
  const url = `v1/orgs/${orgId}/youtube/account`
  return axiosInstance.delete(url)
}

export default youtubeUnlink
